import { IFilter } from "@/api/AppApi/services/filters/interfaces/IGetFilters";
import CheckboxOption from "../../common-filters-components/CheckboxOption";
import { getOptionAvailability } from "../../common-filters-components/option-availability";
import {
  isSelected,
  toggleOption,
} from "../../common-filters-components/toggleOption";
import OptionsDropdown from "@/app/components/common-addons-builder/common-addons-fields/hook-dropdown/options-dropdown/OptionsDropdown";
import { useTranslation } from "@/hooks/localization/useTranslations";

interface props {
  setState: (state: any) => void;
  filter: IFilter;
  state: string[];
  unAvailabeKeys?: string[];
  outOfStockKeys?: string[];
  disabledKeys?: string[];
  allow_user_request_stock_availability_reminder?: boolean;
}
const DropDownFilter: React.FC<props> = ({
  state,
  setState,
  filter,
  unAvailabeKeys = [],
  outOfStockKeys,
  disabledKeys,
  allow_user_request_stock_availability_reminder,
}) => {
  const t = useTranslation();
  const options = filter?.data ?? [];
  const is_multi_select = filter?.configurations?.is_multi_select;
  const handleOption = (key: string) => {
    const currentSelected = toggleOption(state, key, is_multi_select);
    setState(currentSelected);
  };
  return (
    <OptionsDropdown
      title={
        state?.length > 0
          ? state
              ?.map(
                (id: string) =>
                  options[options.findIndex((o) => o.key === id)]?.value,
              )
              .join(", ")
          : t.choose_from_list
      }
    >
      {options
        .filter((op) => !isSelected(unAvailabeKeys, op.key))
        ?.map((op) => {
          const { disabled, outOfStock, allowSelectOutOfStock, isDisabled } =
            getOptionAvailability({
              optionKey: op.key,
              unAvailabeKeys,
              outOfStockKeys,
              disabledKeys,
              allowRequestStockReminder:
                allow_user_request_stock_availability_reminder,
            });
          return (
            <CheckboxOption
              key={op.key}
              label={op.value}
              disabled={disabled}
              checked={isSelected(state, op.key)}
              toggleOption={() => handleOption(op.key)}
              is_multi_select={is_multi_select}
              outOfStock={outOfStock}
              allowSelectOutOfStock={allowSelectOutOfStock}
              isDisabled={isDisabled}
            />
          );
        })}
    </OptionsDropdown>
  );
};

export default DropDownFilter;
